import {
   Document,
   Paragraph,
   Text,
   Bold,
   Italic,
   Strike,
   CustomCode,
   EditableLink,
   CustomHeading,
   History,
   BulletList,
   OrderedList,
   ListItem,
   Blockquote,
   CustomMention,
   CodeBlock,
   MediaManager,
   HardBreak,
   CustomSubscript,
   CustomSuperscript,
   CustomUnderline,
   Video,
} from '../extensions';
import { MenuSeparator } from '../components/MenuSeparator';
import { TiptapMenubar } from '../components/TiptapMenubar';
import { TextStyleDropdown } from '../components/TextStyleDropdown';
import { VideoInsertDropdown } from '../components/VideoInsertDropdown';
import {
   BoldButton,
   ItalicButton,
   CodeButton,
   LinkButton,
   CodeBlockButton,
   BlockquoteButton,
   BulletListButton,
   OrderedListButton,
   IndentButton,
   UnindentButton,
   UndoButton,
   RedoButton,
   InsertImageButton,
} from '../components/buttons';
import type { TiptapExtension } from '.';

export const WikiExtensions: Array<TiptapExtension> = [
   Document,
   Paragraph,
   Text,
   Bold,
   Italic,
   Strike,
   CustomCode,
   EditableLink,
   CustomHeading,
   History,
   BulletList,
   OrderedList,
   ListItem,
   Blockquote,
   CustomMention,
   CodeBlock,
   MediaManager,
   HardBreak,
   CustomSubscript,
   CustomSuperscript,
   CustomUnderline,
   Video,
];

export const WikiMenuBar = (props: any) => {
   return (
      <TiptapMenubar>
         <BoldButton />
         <ItalicButton />
         <CodeButton />
         <LinkButton />
         <MenuSeparator />
         <TextStyleDropdown />
         <MenuSeparator />
         <CodeBlockButton />
         <BlockquoteButton />
         <BulletListButton />
         <OrderedListButton />
         <UnindentButton />
         <IndentButton />
         <MenuSeparator />
         <InsertImageButton />
         <VideoInsertDropdown />
         <MenuSeparator />
         <UndoButton />
         <RedoButton />
      </TiptapMenubar>
   );
};
